/* eslint-env browser */
/**
 * xuehua.js —— 樱花 / 雪花飘落粒子效果
 *
 * 相对原版的修复：
 *  1. 原版顶层 document.writeln 在 webpack 模块加载时会清空整个页面，改为动态创建 DOM；
 *  2. 原版依赖全局 THREE 与 jQuery，改为 window.THREE + 原生 API，不再依赖 jQuery；
 *  3. 粒子贴图由外部传入（组件内通过 webpack 处理资源路径），避免运行时 404；
 *  4. 提供 startSnow / stopSnow，随组件生命周期启停，并清理定时器与事件监听。
 */

let container = null
let renderer = null
let camera = null
let scene = null
let particles = []
let intervalId = null
let snowNum = 500
let mouseX = 0
let mouseY = 0

function createParticle(material) {
  // 优先使用 three.js 内置的全局 Particle3D（带 updatePhysics），缺失时降级为普通粒子
  if (typeof window.Particle3D === 'function') {
    return new window.Particle3D(material)
  }
  const particle = new window.THREE.Particle(material)
  particle.updatePhysics = function () {
    this.position.y -= 2
  }
  return particle
}

function onDocumentMouseMove(event) {
  mouseX = event.clientX - window.innerWidth / 2
  mouseY = event.clientY - window.innerHeight / 2
}

function onDocumentTouchStart(event) {
  if (event.touches.length === 1) {
    event.preventDefault()
    mouseX = event.touches[0].pageX - window.innerWidth / 2
    mouseY = event.touches[0].pageY - window.innerHeight / 2
  }
}

function onDocumentTouchMove(event) {
  if (event.touches.length === 1) {
    event.preventDefault()
    mouseX = event.touches[0].pageX - window.innerWidth / 2
    mouseY = event.touches[0].pageY - window.innerHeight / 2
  }
}

function loop() {
  if (!renderer || !scene || !camera) return
  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0

  for (let i = 0; i < particles.length; i++) {
    const particle = particles[i]
    // 滚动到楼层模块时减少雪花密度（保留原版交互）
    if (scrollTop < 1000) {
      particle.scale.x = particle.scale.y = 1
    } else {
      if (i > (particles.length / 5) * 3) {
        particle.scale.x = particle.scale.y = 0
      } else {
        particle.scale.x = particle.scale.y = 0.8
      }
    }
    if (particle.updatePhysics) particle.updatePhysics()
    const pos = particle.position
    if (pos.y < -1000) {
      pos.y += 2000
    }
    if (pos.x > 1000) {
      pos.x -= 2000
    } else if (pos.x < -1000) {
      pos.x += 2000
    }
    if (pos.z > 1000) {
      pos.z -= 2000
    } else if (pos.z < -1000) {
      pos.z += 2000
    }
  }

  camera.position.x += (mouseX - camera.position.x) * 0.005
  camera.position.y += (-mouseY - camera.position.y) * 0.005
  camera.lookAt(scene.position)
  renderer.render(scene, camera)
}

/**
 * 启动雪花效果
 * @param {Object} options
 * @param {string[]} [options.images] 粒子贴图 URL 列表（最多取前 5 张）
 */
export function startSnow(options = {}) {
  stopSnow()
  if (typeof window === 'undefined') return

  const THREE = window.THREE
  if (!THREE || typeof THREE.CanvasRenderer !== 'function' || typeof THREE.ParticleBasicMaterial !== 'function') {
    console.warn('[LolitaData] three.js 未正确加载，雪花效果已跳过')
    return
  }

  const images = (options.images || []).slice(0, 5)
  if (!images.length) return

  container = document.createElement('div')
  container.className = 'snow'
  container.style.cssText =
    'position:fixed;left:0;top:0;right:0;bottom:0;z-index:9999;' +
    'pointer-events:none;overflow:hidden;background:transparent;'
  document.body.appendChild(container)

  const width = window.innerWidth || 800
  const height = window.innerHeight || 600

  camera = new THREE.PerspectiveCamera(75, width / height, 1, 10000)
  camera.position.z = 1000
  scene = new THREE.Scene()
  scene.add(camera)

  renderer = new THREE.CanvasRenderer()
  renderer.setSize(width, height)
  renderer.domElement.style.cssText =
    'position:absolute;left:0;top:0;width:100%;height:100%;'
  container.appendChild(renderer.domElement)

  const particleImages = images.map(function (src) {
    const img = new Image()
    img.src = src
    return img
  })

  for (let i = 0; i < snowNum; i++) {
    const material = new THREE.ParticleBasicMaterial({
      map: new THREE.Texture(particleImages[i % particleImages.length])
    })
    const particle = createParticle(material)
    particle.position.x = Math.random() * 2000 - 1000
    particle.position.y = Math.random() * 2000 - 1000
    particle.position.z = Math.random() * 2000 - 1000
    particle.scale.x = particle.scale.y = 1
    scene.add(particle)
    particles.push(particle)
  }

  document.addEventListener('mousemove', onDocumentMouseMove, false)
  document.addEventListener('touchstart', onDocumentTouchStart, false)
  document.addEventListener('touchmove', onDocumentTouchMove, false)
  intervalId = setInterval(loop, 1000 / 50)
}

/** 停止并清理雪花效果 */
export function stopSnow() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  document.removeEventListener('mousemove', onDocumentMouseMove, false)
  document.removeEventListener('touchstart', onDocumentTouchStart, false)
  document.removeEventListener('touchmove', onDocumentTouchMove, false)
  if (renderer && renderer.domElement && renderer.domElement.parentNode) {
    renderer.domElement.parentNode.removeChild(renderer.domElement)
  }
  if (container && container.parentNode) {
    container.parentNode.removeChild(container)
  }
  container = null
  renderer = null
  camera = null
  scene = null
  particles = []
  mouseX = 0
  mouseY = 0
}
